import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  root: {
    display: "flex",
    backgroundSize: "100% 100%",
  },
  content: {
    flexGrow: 1,
    minHeight: "100vh",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
  },
  tooltipRoot: {
    "& > div": {
      backgroundColor: theme.palette.tooltipBackground.main,
      color: theme.palette.tooltipText.main,
    },
  },
}));
